import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(4, 1fr)',
		gap: THEME.spacing.md,
		[THEME.queries.lg]: {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},
		[THEME.queries.sm]: {
			gridTemplateColumns: 'repeat(2, 1fr)',
		},
	},
	card: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		backgroundColor: THEME.colors.background.main,
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		':hover': {
			borderColor: THEME.colors.primary.main,
		},
	},
	// Neutralises the shared Button chrome so the thumbnail fills the card edge to edge.
	cardImageButton: {
		padding: 0,
		borderRadius: 0,
		display: 'block',
		width: '100%',
		height: 'auto',
	},
	cardNameRow: {
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
	},
	cardNameInput: {
		width: '100%',
		fontSize: THEME.typography.fontSizes.xs,
	},
	cardNameButton: {
		cursor: 'text',
		display: 'block',
		width: '100%',
		height: 'auto',
		borderRadius: 0,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		textAlign: 'left',
		justifyContent: 'flex-start',
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		...THEME.common.truncate,
		':hover': {
			color: THEME.colors.text.main,
			textDecoration: 'underline',
		},
	},
	cardSelected: {
		borderColor: THEME.colors.primary.main,
		boxShadow: `0 0 0 1px ${THEME.colors.primary.main}`,
	},
	cardImage: {
		width: '100%',
		height: 120,
		objectFit: 'cover',
		display: 'block',
	},
	cardName: {
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		...THEME.common.truncate,
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: THEME.spacing.xl,
	},
	loadMoreTrigger: {
		display: 'flex',
		justifyContent: 'center',
		padding: THEME.spacing.md,
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: THEME.spacing.sm,
		minHeight: 240,
		textAlign: 'center',
		padding: THEME.spacing.xl,
	},
	emptyStateTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	emptyStateDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		maxWidth: 380,
	},
});
